import { render, staticRenderFns } from "./ListaReser.vue?vue&type=template&id=5d05e388&scoped=true"
import script from "./ListaReser.vue?vue&type=script&lang=js"
export * from "./ListaReser.vue?vue&type=script&lang=js"
import style0 from "./ListaReser.vue?vue&type=style&index=0&id=5d05e388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d05e388",
  null
  
)

export default component.exports